<template>
	<article>
		<section class="xbed-sub-title">
			<span>券码列表</span>
		</section>

		<section class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem>营销管理</BreadcrumbItem>
				<BreadcrumbItem>优惠券管理</BreadcrumbItem>
				<BreadcrumbItem>券码列表</BreadcrumbItem>
			</Breadcrumb>
		</section>

		<section style="margin-top: 20px">
			<Form @submit.native.prevent="preventSubmit" inline>
				<FormItem label="优惠券ID：" :label-width="110" style="margin-bottom: 0">
					<span>{{listParams.cardId}}</span>
				</FormItem>
				<br/>
				<FormItem label="优惠券名称：" :label-width="110" style="margin-bottom: 10px">
					<span>{{cardName}}</span>
				</FormItem>
				<br/>
				<FormItem label="领取状态：" :label-width="110">
					<Select v-model="listParams.isReceive" filterable>
						<Option :value="-1">全部</Option>
						<Option :value="1">已领取</Option>
						<Option :value="0">未领取</Option>
					</Select>
				</FormItem>
				<FormItem label="领取账号：" :label-width="110">
					<Input type="text" v-model="listParams.phone" placeholder="手机号"></Input>
				</FormItem>
				<br/>
				<FormItem :label-width="29">
					<Button type="primary" @click="changeQueryKeyWord">查询</Button>
				</FormItem>
				<FormItem prop="addHotel">
					<Button type="primary" @click="exportPromoCode" :loading="exportBtn">导出未领取优惠码</Button>
				</FormItem>
			</Form>
			<Table stripe :loading="listResp.loading" :columns="column" :data="listResp.data" style="width: 1134px;"></Table>
			<div style="margin: 10px;overflow: hidden">
				<Page show-sizer show-total placement="top" :total="listResp.count" :current="listParams.page" :page-size="listParams.size" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
			</div>
		</section>
	</article>
</template>

<script>
/* eslint-disable */
import Moment from "moment";
import Utils from "../../utils";
import Config from "../../config";
import API from "../../api";
import {STORE_KEY} from "../../constants"

export default {
	async created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );

		this.listParams.cardId = Utils.getUrlParameterByName( "cardId" );
		this.cardName = Utils.getUrlParameterByName( "cardName" );

		// 阿里云接口，header 传参（只有开发环境和测试环境需要传 group）
    this.protHeaders = {
      'x-ca-stage': Utils.aliHeaderEnv(this.env), 
      'Authorization': Utils.findFromLocalStorage("Author-token"),
      // 'secret': '58dbac0cb9a1db115a473199f8d312e6',
    }
    if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'testing') {
      this.protHeaders.group = process.env.NODE_ENV === 'development' ? 'dev' : 'qa'
    }
	},
	async mounted() {
		this.$Notice.config( {
			top: 200
		} );

		this.queryCodesByCardId();
	},
	data() {
		return {
			exportBtn: false,
			column: [
				{
					title: "优惠码",
					key: "promoCode",
					align: "center",
					width: 250,
					// render: ( h, params ) => {
					// 	let promoCode = params.row.promoCode;
					// 	if ( !params.row.issuer ) {
					// 		var len = params.row.promoCode.length;
					// 		promoCode = params.row.promoCode.substr( 0, len - 4 ) + "****";
					// 	}
					// 	return h( "div", {}, promoCode );
					// }
				},
				{
					title: "领取状态",
					key: "receiveStat",
					align: "center",
					width: 120,
					render: (h, params) => {
						return h('span', {}, ['未领取', '已领取'][params.row.receiveStat])
					}
				},
				{
					title: "领取时间",
					key: "receiveTimestamp",
					align: "center",
					width: 200,
					render: ( h, params ) => {
						let receiveTimestamp = '-'
						if ( params.row.receiveTimestamp ) {
							receiveTimestamp = Moment( params.row.receiveTimestamp ).format( "YYYY-MM-DD HH:mm:ss" );
						}
						return h( "div", {}, receiveTimestamp );
					}
				},
				{
					title: "领取账号",
					key: "phone",
					align: "center",
					width: 200,
					render: (h, params) => {
						return h('span', {}, params.row.phone || '-')
					}
				},
				{
					title: "优惠券有效日期",
					align: "center",
					width: 150,
					render: ( h, params ) => {
						let beginTimestamp = params.row.beginTimestamp
						let endTimestamp = params.row.endTimestamp
						return h( "div", {},  beginTimestamp && endTimestamp ? beginTimestamp + ' 至 ' + endTimestamp : '-');
					}
				},
				{
					title: "使用时间",
					key: "useDatetime",
					align: "center",
					width: 210,
					render: (h, params) => {
						return h('span', {}, params.row.useDatetime || '-')
					}
				}
			],

			// 优惠券优化 - modify by lty  20200217
			listParams: {
				page: 1,
				size: 10,
				cardId: '',
				isReceive: -1,
				phone: ''
			},
			listResp: {
				data: [], // 列表结果数据
				count: 0, // 总数
				loading: false
			}
		};
	},
	methods: {
		// 阻止form回车提交事件
		preventSubmit() {
			return false;
		},
		async queryCodesByCardId() {
			this.listResp.loading = true;
			let params = this.listParams
      params = Object.keys(params).reduce(function(c, k) {
        if (params[k] === 0 || (params[k] && params[k] !== -1)) {
          c[k] = params[k]
        }
        return c
			}, {})
			try {
				let resp = (await API.omsAPI[this.env].clientServer.getCodesByCardId(params, this.protHeaders)).data;
				this.listResp.loading = false
				if ( resp.retCode ) {
					this.$Notice.error({
						title: '获取券码数据异常',
						desc: resp.msg
					})
					return
				}
				this.listResp.data = resp.list
				this.listResp.count = resp.total;

			} catch (e) {
				this.listResp.loading = false
				this.$Notice.error({
					title: '服务器异常，请稍后再试'
				})
			}
		},		
    // 查询
    changeQueryKeyWord(){
      this.listParams.page = 1
      this.queryCodesByCardId()
    },
		changePage( pageIndex ) {
			this.listParams.page = pageIndex;
			this.queryCodesByCardId();
		},
		changePageSize( pageSize ) {
			this.listParams.page = 1;
			this.listParams.size = pageSize;
			this.queryCodesByCardId();
		},
		
		// 导出未领取优惠码
		exportPromoCode() {
			if ( !this.checkHasPermission( 'excel_exportPromoCode' ) ) {
				return;
			}
			let url = `${ Config[this.env].analysisUrl }excel/exportPromoCode?cardId=${ this.listParams.cardId }`;
			// window.open(url);
			Utils.exportExcelWeighting( url, this.token, this.$Notice.error, this, "exportBtn" )

		},
		checkHasPermission( name ) {
			if ( !Utils.hasPermission( name ) ) {
				this.$Notice.error( {
					title: Utils.getFromStore( STORE_KEY.STORE_KEY_NOT_PERMISSION_TIPS )
				} );

				return false;
			}
			return true;
		},
	}
};
</script>

<style lang="scss">
.hidden-header-selection
	.ivu-table
	.ivu-table-header
	th.ivu-table-column-center
	div.ivu-table-cell
	.ivu-checkbox-wrapper {
	display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/marketing/code-store.vue